import React from 'react'
import WelcomeBotIcon from '../../app/components/svgIcons/WelcomeBotIcon'
import { StyledLabel } from '../../assets/styledComponents/Global'
import { useTheme } from 'styled-components';
import { useWindowSize } from '../../utils/helper';
import StyledButton from '../../app/components/styledComponents/StyledButton';
import EmptyIcon from '../../app/components/svgIcons/EmptyIcon';

const InterviewDone = ({ videoProfileRes, submitLoading, answerSubmit, expired, message }) => {
    const theme = useTheme();
    const isSmallScreen = useWindowSize();

    return (
        <div
            className={`d-flex align-items-center justify-content-center flex-column text-white ${isSmallScreen && 'mt-5 pt-5'
                }`}
        >
            {expired ? <EmptyIcon /> : <WelcomeBotIcon className={`${isSmallScreen && 'mt-5'}`} />}

            <StyledLabel
                size="22px"
                fontWeight="600"
                color={theme?.primary}
                className="mt-3 text-center"
            >
                {expired ? message || 'Your Video Profile is Expired' : '🎉 Assessment already completed!'}
            </StyledLabel>
            {!expired && <p className='text-primary'>You’ve answered all questions.</p>}


            {videoProfileRes?.videoApplication?.isComplete === 0 && !expired && (
                <>
                    <p className='text-primary'>You Just need to submit your Answers.</p>
                    <StyledButton loading={submitLoading} onClick={() => answerSubmit()}>
                        Submit Assessment
                    </StyledButton>
                </>

            )}
        </div>
    )
}

export default InterviewDone